import { render, staticRenderFns } from "./section-file-edit.html?vue&type=template&id=2d6aed00&scoped=true&"
import script from "./section-file-edit.js?vue&type=script&lang=js&"
export * from "./section-file-edit.js?vue&type=script&lang=js&"
import style0 from "./section-file-edit.css?vue&type=style&index=0&id=2d6aed00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6aed00",
  null
  
)

export default component.exports